import React, { useState, useCallback, memo } from 'react'
import FAQTransport from '../../../transports/common/faq-transport'
import { ChevronDownIcon } from '../icons'
import {
    FaqItem as FaqItemStyled,
    QuestionButton,
    Question,
    IconWrapper,
    AnswerWrapper,
    AnswerContent,
    CustomMarkdown,
} from './styles'

interface FaqItemProps {
    faq: FAQTransport
}

const FaqItem: React.FC<FaqItemProps> = ({ faq }) => {
    const [isOpen, setIsOpen] = useState(false)

    const handleToggle = useCallback(() => {
        setIsOpen(prev => !prev)
    }, [])

    return (
        <FaqItemStyled>
            <QuestionButton onClick={handleToggle} aria-expanded={isOpen}>
                <Question>{faq.question}</Question>
                <IconWrapper isOpen={isOpen}>
                    <ChevronDownIcon aria-label="Toggle Answer" />
                </IconWrapper>
            </QuestionButton>
            <AnswerWrapper isOpen={isOpen}>
                <AnswerContent>
                    <CustomMarkdown>{faq.answer}</CustomMarkdown>
                </AnswerContent>
            </AnswerWrapper>
        </FaqItemStyled>
    )
}

export default memo(FaqItem)
